import {ComponentChildren} from "preact";
import {useRef, useState} from "preact/hooks";
import {mdiChevronDown, mdiChevronUp} from "@mdi/js";
import Icon from "@mdi/react";
import {Button} from "./button";
import {JSXInternal} from "preact/src/jsx";
import {
    FloatingFocusManager,
    FloatingPortal,
    useClick,
    useDismiss,
    useFloating,
    useInteractions,
    useRole,
    shift,
} from "@floating-ui/react";

export type DropdownProps = {
    children?: ComponentChildren;
    content: JSXInternal.Element;
    position?: "top" | "bottom" | "left" | "right";
    title?: string;
    showChevron?: boolean;
}

export function Dropdown(props: DropdownProps) {
    const [dropdownVisible, setDropdownVisible] = useState<boolean>(false);
    const ref = useRef<HTMLElement>(null);
    const {context, refs, x, y} = useFloating({
        open: dropdownVisible,
        onOpenChange: setDropdownVisible,
        elements: {
            reference: ref.current,
        },
        placement: props.position ?? "bottom",
        strategy: "absolute",
        middleware: [shift()],
    });
    const click = useClick(context, {enabled: true});
    const dismiss = useDismiss(context, { outsidePressEvent: "mousedown", enabled: true });
    const role = useRole(context);
    const interactions = useInteractions([click, dismiss, role]);

    return <>
        {dropdownVisible && <FloatingPortal>
            <FloatingFocusManager context={context}>
                <div
                    ref={refs.setFloating}
                    {...interactions.getFloatingProps()}
                    style={{
                        position: "absolute",
                        top: y,
                        left: x
                    }}
                >
                    {props.content}
                </div>
            </FloatingFocusManager>
        </FloatingPortal>}
        <Button
            ref={ref}
            className="btn"
            title={props.title}
            onClick={(e: MouseEvent) => {
                e.preventDefault();
                e.stopPropagation();

                console.log("click");

                setDropdownVisible(!dropdownVisible);
            }}
        >
            {props.children}
            {props.showChevron ?? true ? <Icon size="1em" path={dropdownVisible ? mdiChevronUp : mdiChevronDown} /> : null}
        </Button>
    </>;
}
